import React from 'react';
import ConditionalWrapperProps from './ConditionalWrapperProps';

const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export default ConditionalWrapper;
